import { createRoot } from "react-dom/client";
import Login from "./components/Login";
import Inicio from "./components/Inicio";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import InicioContext from "./components/InicioContext";
import React, { useEffect, useRef, useState } from "react";
import swal from "sweetalert";
import "react-circular-progressbar/dist/styles.css";
import Catalog from "./components/Catalog";
import App from "./components/App";
import { AuthContext } from "./components/AuthContext";
import Ideias from "./components/Ideias";
import Perfil from "./components/Perfil";

function Index() {
  const backEnd = "https://api-book-flow.vercel.app";
  const [count, setCount] = useState(0);
  const [page, setPage] = useState("");
  const [BookInformations, setBookInformations] = useState({
    titles: "",
    imgs: "",
    pages: "",
    desc: "",
  });
  const [Catalogo, setCatalogo] = useState([
    {
      from: "Catalogo",
      titles: "",
      imgs: "",
      pages: "",
      desc: "",
      final: "",
    },
  ]);
  const [Finalizados, setFinalizados] = useState([
    {
      from:"Finalizados",
      titles: "",
      imgs: "",
      pages: "",
      final: "",
    },
  ]);
  const [SelectBook, setSelectBook] = useState({
    titles: "",
    imgs: "",
    pages: "",
    desc: "",
    final: "",
    id: "",
  });
  const [statusStyle, setStatusStyle] = useState("Status");

  useEffect(() => {
    HoldPage();
  }, [page]);

  useEffect(() => {
    style();
  }, [count, SelectBook, Catalogo]);
  useEffect(
    () => {
      GetCatalogo();
      GetFinalizados();
    },
    [],
    [count],
  );

  async function update() {
    setCount((prevCount) => {
      // Initialize prevCount to 0 when adding a new book
      if (Catalogo[SelectBook.id]?.titles !== SelectBook.titles) {
        prevCount = 0;
      }

      var newCount = prevCount + 1;

      if (newCount > 10) {
        newCount = Math.round(newCount / 10) + 1;
      }

      setCatalogo((prevEvent) => {
        const updatedEvent = [...prevEvent];

        if (updatedEvent[SelectBook.id]) {
          updatedEvent[SelectBook.id] = {
            ...updatedEvent[SelectBook.id],
            final: newCount,
          };
        }

        return updatedEvent;
      });

      return newCount;
    });
  }

  useEffect(() => {
    async function updateCatalogoAndFetch() {
      // Fetch and update the book in the backend
      const response = await fetch(backEnd + "/update", {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(Catalogo[SelectBook.id]),
      });

      if (response.status === 400) {
        console.log("Bad Request: Everything Up to Date");
      } else if (response.status === 401) {
        // Unauthorized status code
        return;
      } else {
        const responseData = await response.json(); // Parse JSON content from response
        console.log("Updated Catalogo:");
        console.log("Response Message:", responseData.message);
      }
    }

    updateCatalogoAndFetch();
  }, [Catalogo]);

  function GetCatalogo() {
    fetch(backEnd + "/getcatalogo", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`, // Include the token in the Authorization header
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message !== "Unauthorized") {
          return setCatalogo(data.books);
        } else {
          return;
        }
      });
  }
  function GetFinalizados() {
    fetch(backEnd + "/getfinalizados", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`, // Include the token in the Authorization header
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message !== "Unauthorized") {
          return setFinalizados(data.books);
        } else {
          return;
        }
      });
  }

  async function sendData(dataToSend) {
    const response = await fetch(backEnd + "/api", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(dataToSend),
    });
    const data = await response.json();
    setBookInformations(function () {
      return {
        titles: data.booksTitle,
        imgs: data.booksimg,
        pages: data.pages,
        desc: data.desc,
      };
    });
  }

  function verify() {
    setCount(SelectBook.final || 0);
    for (let i = 0; i < Catalogo.length; i++) {
      if (SelectBook.titles === Catalogo[i].titles) {
        setCount(Catalogo[i].final);
        return;
      }
    }

    for (let i = 0; i < Finalizados.length; i++) {
      if (SelectBook.titles === Finalizados[i].titles) {
        setCount(Finalizados[i].final);
        lectureStarted();
        return;
      } else {
        setCount(0);
      }
    }
  }
  function selectBook(event) {
    const i = event.target.id;
    verify();

    setSelectBook({
      titles: Catalogo[i].titles,
      imgs: Catalogo[i].imgs,
      pages: Catalogo[i].pages,
      desc: Catalogo[i].desc,
      final: Catalogo[i].final,
      id: i,
    });
    style();
    setCount(Catalogo[i].final);
  }

  function style() {
    if (count < 1) {
      setStatusStyle("Status");
    } else {
      setStatusStyle("Status-open");
    }
  }

  function HoldPage(event) {
    event ? setPage(event.target.value) : setPage("");

    var dataToSend = { book: page };
    if (page.length > 5) {
      sendData(dataToSend);
    } else {
      setBookInformations("");
    }
  }
  function Enter(event) {
    HoldPage(event);
    event.preventDefault();
  }

  ///Defining Books/////

  function titlesDefine(titles, i) {
    return (
      <div className="divBook" onClick={saveBook} value={i}>
      
        <p className="title" value={i}>
          {titles}
        </p>

        <img
          className="imgSearch"
          value={i}
          src={BookInformations.imgs[i]}
          alt="BookImg"
        />
        <p value={i} className="pages">
          {BookInformations.pages[i]} Páginas
        </p>
        <p>
          <i value={i} className="fa-solid fa-circle-plus"></i>
        </p>
      </div>
    );
  }

  async function saveBook(event) {
    close();
    if (Catalogo.length < 100) {
      const i = event.target.attributes.value.value;
      for (var c = 0; c < Catalogo.length; c++) {
        
        if (Catalogo[c].titles === BookInformations.titles[i] || Finalizados[c <= Finalizados.length ? c : null].titles === BookInformations.titles[i]) {
          return swal("Esse Livro Já esta na sua Lista", {
            buttons: false,
            timer: 1000,
          });
        }
      }
      setCatalogo((prevCatalogo) => {
        const bookInfo = {
          titles: BookInformations.titles[i],
          imgs: BookInformations.imgs[i],
          pages: BookInformations.pages[i] || "Este Livro não Tem Número de Paginas",
          desc: BookInformations.desc[i] || "Este Livro não Tem Descrição",
          final: 0,
        };
        function fetchData(){
          fetch(backEnd + "/saveList", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(bookInfo),
          });
        }

        if (prevCatalogo.length === 0 || bookInfo.imgs === "") {
          fetchData();
          return [bookInfo];
        }
        fetchData();
        return [...prevCatalogo, bookInfo];
      });
    } else {
      swal("Catalogo Cheio", {
        buttons: false,
        timer: 1000,
      });
    }

  }


  
  function createCatalogo(Catalogo, i) {
   
    if(Catalogo.from === "Inicio"){
      const [Show, setShow] = useState(false);
      const descriptionRef = useRef(null);
      

      return (
        
          <div className={!Show ?"book-grid-item" : "book-flex-item"}   ref={descriptionRef} >
          {Catalogo.imgs ? (
            <>
              <img
              
                onClick={
                  Catalogo.desc
                    ? selectBook
                    : () => {
                        swal("Good job!", "Livro Finalizado", "success", {
                          timer: 1500,
                          buttons: false,
                        });
                      }
                      
                }
            
                className="imgCatalogo"
                src={Catalogo.imgs}
                alt="BookImg"
                id={i}

         
              />
              <div>
                <p  className="book-title">{Catalogo.titles}</p>

                {Show? (
                  
                  <p        className="book-description">{Catalogo.desc}</p>
                ) : null}
                {Catalogo.pages ? (
                  <p className="book-pages">Páginas: {Catalogo.pages}</p>
                ) : null}
                {Catalogo.author ? (
                  <p className="book-author">Autor: {Catalogo.author}</p>
                ) : null}
                {Catalogo.rating ? (
                  <div className="book-rating">
                    Avaliação: {Catalogo.rating} / 5
                  </div>
                ) : null}
                {Catalogo.price ? (
                  <div className="book-price">Preço: R$ {Catalogo.price}</div>
                ) : null}
                <button
  className="button-draw"
  onClick={() => {
    setShow((prevShow) => {
      // Use prevShow (valor anterior de Show) para determinar o comportamento
        
          setTimeout(() => {
            descriptionRef.current.scrollIntoView({ behavior: "smooth" ,block: "center"});
          }, 250);

      
      return !prevShow; // Alterna o valor de Show
    });
  }}
>
  {Show ? "Ler Menos" : "Ler Mais"}
</button>
              </div>
            </>
          ) : (
            <div>Vazio</div>
          )}
        </div>
        
      );
    }else{
      return (
        <div className="book-grid-item">
          {Catalogo.imgs ? (
            <>
              {Catalogo.desc && Catalogo.from !== "Inicio" ? (
                <button className="deleteBook" onClick={deleteBook} id={i}>
                  <i id={i} className="fa-solid fa-xmark"></i>
                </button>
              ) : null}
              <img
                onClick={
                  Catalogo.desc
                    ? selectBook
                    : () => {
                        swal("Good job!", "Livro Finalizado", "success", {
                          timer: 1500,
                          buttons: false,
                        });
                      }
                }
                className="imgCatalogo"
                src={Catalogo.imgs}
                alt="BookImg"
                id={i}
              />
              <div>
                <p className="book-title">{Catalogo.titles}</p>
  
  
                {Catalogo.pages ? (
                  <p className="book-pages">Páginas: {Catalogo.pages}</p>
                ) : null}
                {Catalogo.author ? (
                  <p className="book-author">Autor: {Catalogo.author}</p>
                ) : null}
                {Catalogo.rating ? (
                  <div className="book-rating">
                    Avaliação: {Catalogo.rating} / 5
                  </div>
                ) : null}
                {Catalogo.price ? (
                  <div className="book-price">Preço: R$ {Catalogo.price}</div>
                ) : null}
              </div>
            </>
          ) : (
            <div>Vazio</div>
          )}
        </div>
      );
    }
    
  }
  
  ////---------------------------/////

  ////Functions Delete/////


  function close() {
    setSelectBook({
      titles: "",
      imgs: "",
      pages: "",
      final: "",
    });
  }

  function deleteBook(event) {
    const i = event.target.id;
    close();
    setCatalogo(function (prevEvent) {
      const updatedEvent = [...prevEvent];

      updatedEvent.splice(i, 1);
      return updatedEvent;
    });
    fetch(backEnd + "/delete", {
      withCredentials: true,
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(Catalogo[i]),
    });
  }

  ////-----------------/////

  function Fim() {
    const i = SelectBook.id;
    
    setCatalogo(function (prevEvent) {
      const updatedEvent = [...prevEvent];

      updatedEvent.splice(i, 1);
      return updatedEvent;
    });
    setFinalizados((prevEvent)=>{
      const bookData = {
        titles: SelectBook.titles,
        imgs: SelectBook.imgs,
        pages: SelectBook.pages,
        final: count,
      };

      function fetchData() {
        fetch(backEnd + "/saveFinalizados", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // Include the token in the Authorization header
          },
          body: JSON.stringify(bookData),
        });
        
      }
      
      if (prevEvent.titles ? prevEvent[0].titles === "" : null) {
        fetchData();
        return [bookData];
      }
      close();
      fetchData();
      return [...prevEvent, bookData];
    });
  }

  function lectureStarted() {
    if (count < 7) {
      update();
    } else {
      Fim();
    }
    style();
  }

  const initialToken = localStorage.getItem("token");
  const [token, setToken] = useState(initialToken ? initialToken : "");

  useEffect(() => {
    localStorage.setItem("token", token);
  }, [token]);

  const tokenFiles = {
    token: token,
    setToken: setToken,
    savedToken: localStorage.getItem("token"),
    backEnd: backEnd,
  };
  const dataToInicio = {
    backEnd: backEnd,
    HoldPage: HoldPage,
    setPage: setPage,
    Enter: Enter,
    BookInformations: BookInformations,
    titlesDefine: titlesDefine,
    createCatalogo: createCatalogo,
    Catalog: Catalog,
    Catalogo: Catalogo,
    Finalizados: Finalizados,
    statusStyle: statusStyle,
    SelectBook: SelectBook,
    lectureStarted: lectureStarted,
    count: count,
    close: close,
    
    GetCatalogo:GetCatalogo,
    GetFinalizados:GetFinalizados,
  };

  return (
    <AuthContext.Provider value={tokenFiles}>
      <InicioContext.Provider value={dataToInicio}>
        <Router>
          <Routes>
            <Route path="/" element={<Inicio />} />
            <Route path="/catalogo" element={<App />} />
            <Route path="/login" element={<Login />} />
            <Route path="/ideias" element={<Ideias />} />
            
            <Route path="/perfil" element={<Perfil />} />
          </Routes>
        </Router>
      </InicioContext.Provider>
    </AuthContext.Provider>
  );
}

const domNode = document.getElementById("root");
const root = createRoot(domNode);
root.render(<Index />);
